export default __webpack_public_path__ + "static/article-finance-redefining-work-12bd9037131f6cdb299461b4c73521ea.jpg";